// components/ContentFlagSelector.jsx
import React from "react";

const FLAG_OPTIONS = [
  { key: "no_gore", label: "No Gore" },
  { key: "no_politics", label: "No Politics" },
  { key: "no_trauma", label: "No Trauma" },
  { key: "no_nudity", label: "No Nudity" },
  { key: "no_abuse", label: "No Abuse" },
  { key: "no_violence", label: "No Violence" },
];

export default function ContentFlagSelector({ selectedFlags = {}, onChange }) {
  const toggleFlag = (key) => {
    onChange({
      ...selectedFlags,
      [key]: !selectedFlags[key],
    });
  };

  return (
    <div className="mb-4">
      <p className="text-sm font-semibold mb-1">⚠️ Content Flags</p>
      <div className="flex flex-wrap gap-2">
        {FLAG_OPTIONS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            className={`px-2 py-1 text-xs rounded-full font-medium border transition ${
              selectedFlags[key]
                ? "bg-red-100 text-red-800 border-red-400"
                : "bg-gray-100 text-gray-700 border-gray-300"
            }`}
            onClick={() => toggleFlag(key)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
